export default "assets/images/shadow-wine-b34288b5.png";